// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1YErr","list":"Footer_list__2Tgu5","listItem":"Footer_listItem__8BjFX","link":"Footer_link__1B3Lp"};